import { Menu } from 'lucide-react';
import React, { useState } from 'react';
import { useSection } from '@/app/providers';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';

interface AdminLayoutV2Props {
  children: React.ReactNode;
}

export const AdminLayoutV2: React.FC<AdminLayoutV2Props> = ({ children }) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const { isSectionAdmin, selectedSectionId, loading: sectionsLoading } = useSection();

  return (
    <div className="min-h-screen bg-theme flex font-sans">
      <Sidebar mobileOpen={mobileOpen} onMobileClose={() => setMobileOpen(false)} />

      <div className="flex-1 flex flex-col min-w-0 h-screen overflow-hidden">
        {/* Mobile header bar */}
        <div className="md:hidden glass-heavy px-4 py-3 flex items-center gap-3 border-b border-theme-light z-10 sticky top-0">
          <button
            onClick={() => setMobileOpen(true)}
            className="p-2 rounded-lg hover:bg-surface-secondary text-theme-secondary"
          >
            <Menu size={20} />
          </button>
          <Topbar />
        </div>

        {/* Desktop topbar */}
        <div className="hidden md:block">
          <Topbar />
        </div>

        <main className="flex-1 overflow-y-auto p-4 md:p-6 bg-theme">
          {/* El admin de sección ve una sola sección: se espera a conocerla y, al
              cambiarla, se remonta la página para que todo se vuelva a pedir. */}
          {!(isSectionAdmin && sectionsLoading) && (
            <div
              key={isSectionAdmin ? (selectedSectionId ?? 'none') : 'all'}
              className="max-w-screen-2xl mx-auto animate-fade-in"
            >
              {children}
            </div>
          )}
        </main>
      </div>

      {/* <AskHommiFab /> */}
    </div>
  );
};
